import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  queryKey?: string;
}
export function useGetFiltrarEquipes(props: Props) {
  const fetchData = async () => {
    const FILTRAR_EQUIPES = `${leadsWebEnviroment}/common/campanha/equipes/v1`;
    const response = await instance.get(FILTRAR_EQUIPES);
    return response?.data?.data;
  };

  const query = useQuery({
    enabled: true,
    queryFn: fetchData,
    queryKey: [props.queryKey || "filtrar_equipes"],
    refetchOnWindowFocus: false,
  });

  return query;
}
